import "../../css/pages/article.scss";
import sectionNav from "../modules/sectionNav";

import BasePage from "./base";
import PageHero from "../modules/pageHero";

class ArticlePage extends BasePage {
    constructor(...opts) {
        super(...opts);
    }

    init() {
        super.init();
        new PageHero();
    }

    onReady() {
        super.onReady();
        sectionNav.init();
    }
}

new ArticlePage();
